<template>
    <div :class="['socials', { square: square, circular: circular, alt: alt }]">
        <template v-for="social in socialsLists">
            <a
                v-if="checkLink(social.name) && !newSocials.includes(social.name)"
                :key="`social-${social.name}`"
                :href="checkLink(social.name) ? checkLink(social.name) : social.href"
                class="socials__item"
                :target="target"
            >
                <img
                    v-if="svg"
                    :style="{ width: `${svgSize}`, height: `${svgSize}` }"
                    :src="checkSvg(social.name) ? svgs[social.name] : require(`./assets/${social.name}/${svgImage}`)"
                >

                <template v-else>
                    <y-icon
                        v-if="checkIcon(social.name) || social.icon"
                        :icon="checkIcon(social.name) ? checkIcon(social.name) : social.icon"
                        :library="social.library"
                        :prefix="social.prefix"
                        :color="color"
                        :size="size"
                    />
                    <img
                        v-else-if="social.svg"
                        :style="{ width: `${svgSize}`, height: `${svgSize}` }"
                        :src="checkSvg(social.name) ? svgs[social.name] : require(`./assets/${social.name}/${svgImage}`)"
                    >
                </template>
            </a>
        </template>

        <slot />
    </div>
</template>

<script>
    // eslint-disable-next-line import/no-cycle
    import { YIcon } from '@groot-components/icon';

    export default {
        name: 'Socials',

        components: {
            YIcon,
        },

        props: {
            /**
             * Color icons
             */
            color: String,

            /**
             * Icon Sizes
             */
            size: String,

            /**
             * Square Icon Box
             */
            square: {
                type   : Boolean,
                default: false,
            },

            /**
             * Circular Icon Box
             */
            circular: {
                type   : Boolean,
                default: false,
            },

            /**
             * Alt Style
             */
            alt: {
                type   : Boolean,
                default: false,
            },

            /**
             * Facebook link
             * Activates Icon
             */
            facebook: String,

            /**
             * Twitter link
             * Activates Icon
             */
            twitter: String,

            /**
             * Instagram link
             * Activates Icon
             */
            instagram: String,

            /**
             * Telegram link
             * Activates Icon
             */
            telegram: String,

            /**
             * Linkedin link
             * Activates Icon
             */
            linkedin: String,

            /**
             * Pinterest link
             * Activates Icon
             */
            pinterest: String,

            /**
             * Github link
             * Activates Icon
             */
            github: String,

            /**
             * Wordpress link
             * Activates Icon
             */
            wordpress: String,

            /**
             * Dribble link
             * Activates Icon
             */
            dribbble: String,

            /**
             * Behance link
             * Activates Icon
             */
            behance: String,

            /**
             * Youtube link
             * Activates Icon
             */
            youtube: String,

            /**
             * Whatsapp link
             * Activates Icon
             */
            whatsapp: String,

            /**
             * Aparat link
             * Activates Icon
             */
            aparat: String,

            /**
             * Virgool link
             * Activates Icon
             */
            virgool: String,

            /**
             * Link's Target
             */
            target: {
                type   : String,
                default: '_blank',
            },

            /**
             * Share data like url, title and title2
             */
            share: Object,

            /**
             * Should Use SVG as social image
             */
            svg: Boolean,

            /**
             * Size of the svg
             */
            svgSize: {
                type   : String,
                default: '25px',
            },

            /**
             * If the icons should be rounded
             */
            rounded: Boolean,

            /**
             * Icon Sets
             */
            icons: Object,

            /**
             * SVG Sets
             */
            svgs: Object,

            /**
             * Share Links Sets
             */
            shareLinks: Object,

            /**
             * New Socials Sets
             */
            socials: Array,
        },

        computed: {
            /**
             * If it is share component
             * 
             * @returns {*}
             */
            isShare() {
                return this.share && this.share.url;
            },

            /**
             * Return the proper svg file name
             * 
             * @returns {*}
             */
            svgImage() {
                const color = this.color ? 'colored' : 'mono';
                const type = this.rounded ? 'rounded' : 'square';
                return `${color}-${type}.svg`;
            },

            /**
             * Return the list of the Default Socials
             * 
             * @returns {*}
             */
            lists() {
                return [
                    {
                        name  : 'facebook',
                        href  : this.facebook,
                        icon  : 'facebook',
                        prefix: 'fab',
                        order : 1,
                    },
                    {
                        name  : 'twitter',
                        href  : this.twitter,
                        icon  : 'twitter',
                        prefix: 'fab',
                        order : 2,
                    },
                    {
                        name  : 'instagram',
                        href  : this.instagram,
                        icon  : 'instagram',
                        prefix: 'fab',
                        order : 3,
                    },
                    {
                        name  : 'telegram',
                        href  : this.telegram,
                        icon  : 'telegram',
                        prefix: 'fab',
                        order : 3,
                    },
                    {
                        name  : 'linkedin',
                        href  : this.linkedin,
                        icon  : 'linkedin',
                        prefix: 'fab',
                        order : 4,
                    },
                    {
                        name  : 'pinterest',
                        href  : this.pinterest,
                        icon  : 'pinterest',
                        prefix: 'fab',
                        order : 5,
                    },
                    {
                        name  : 'github',
                        href  : this.github,
                        icon  : 'github',
                        prefix: 'fab',
                        order : 6,
                    },
                    {
                        name  : 'youtube',
                        href  : this.youtube,
                        icon  : 'youtube',
                        prefix: 'fab',
                        order : 7,
                    },
                    {
                        name  : 'whatsapp',
                        href  : this.whatsapp,
                        icon  : 'whatsapp',
                        prefix: 'fab',
                        order : 8,
                    },
                    {
                        name : 'aparat',
                        href : this.aparat,
                        // eslint-disable-next-line global-require
                        svg  : require(`./assets/aparat/${this.svgImage}`), // eslint-disable-line import/no-dynamic-require
                        order: 9,
                    },
                    {
                        name : 'virgool',
                        href : this.virgool,
                        // eslint-disable-next-line global-require
                        svg  : require(`./assets/virgool/${this.svgImage}`), // eslint-disable-line import/no-dynamic-require
                        order: 10,
                    },
                ];
            },

            /**
             * Return the list of share link
             * 
             * @returns {*}
             */
            shareLinksDefaults() {
                return {
                    facebook: `https://www.facebook.com/sharer.php?u=${this.share.url}`,
                    twitter : `https://twitter.com/intent/tweet?url=${this.share.url}&text=${this.share.title ? this.share.title : ''}`,
                    telegram: `https://t.me/share/url?url=${this.share.url}&text=${this.share.title ? this.share.title : ''}`,
                    whatsapp: `whatsapp://send?text=${this.share.title ? this.share.title : ''} ${this.share.url}`,
                };
            },

            /**
             * List of new Socials
             * 
             * @returns {*}
             */
            newSocials() {
                const names = [];
                if (this.socials) {
                    Object.keys(this.socials).forEach((key) => {
                        names.push(this.socials[key].name);
                    });
                }
                return names;
            },

            /**
             * List of new Socials
             * 
             * @returns {Array}
             */
            socialsLists() {
                return this.socials && this.socials.length ? [...this.lists, ...this.socials] : this.lists;
            },
        },

        methods: {
            /**
             * Check if svg image is provided
             *
             * @param {*} name
             * @returns {*}
             */
            checkSvg(name) {
                if (this.svgs && this.svgs[name]) {
                    return this.svgs[name];
                }
                return false;
            },

            /**
             * Check if icon is provided
             *
             * @param {*} name
             * @returns {*}
             */
            checkIcon(name) {
                if (this.icons && this.icons[name]) {
                    return this.icons[name];
                }
                return null;
            },

            /**
             * Check link
             *
             * @param {*} name
             * @returns {*}
             */
            checkLink(name) {
                let link = null;
                if (this.isShare) {
                    if (this.shareLinks && this.shareLinks[name]) {
                        link = this.shareLinks[name];
                    } else {
                        link = this.shareLinksDefaults[name] || null;
                    }
                } else {
                    link = this.lists.find( (item) => item.name === name )?.href;
                }
                return link;
            },
        },
    };
</script>
